module.exports = __webpack_public_path__ + "static/media/affiliate-profile.4e652903.png";